import React from 'react';
import styles from './ui-avatar.module.scss';

interface UIAvatarProps {
    size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
    src?: string;
    initials?: string;
    bordered?: boolean;
    className?: string;
}

export function UIAvatar({
    size = 'md',
    src,
    initials,
    bordered = false,
    className = '',
}: UIAvatarProps) {
    const classes = [
        styles.avatar,
        styles[`size-${size}`],
        bordered ? styles.bordered : '',
        className,
    ].filter(Boolean).join(' ');

    if (src) {
        return (
            <div className={classes}>
                <img src={src} alt="" className={styles.image} />
            </div>
        );
    }

    return (
        <div className={classes}>
            <span className={styles.initials}>{initials || '?'}</span>
        </div>
    );
}

export default UIAvatar;
